import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  // L1 titles
  animeTitle: { defaultMessage: 'Anime' },
  booksTitle: { defaultMessage: 'Books' },
  musicTitle: { defaultMessage: 'Music' },
  televisionTitle: { defaultMessage: 'Television' },
  moviesTitle: { defaultMessage: 'Movies' },
  animalsTitle: { defaultMessage: 'Animals' },
  gamingTitle: { defaultMessage: 'Gaming' },
  sportsTitle: { defaultMessage: 'Sports' },
  funnyTitle: { defaultMessage: 'Funny' },

  // L1 attributive titles — modifier form used before a product type, e.g. "Animal Stickers"
  animeAttributiveTitle: { defaultMessage: 'Anime' },
  booksAttributiveTitle: { defaultMessage: 'Book' },
  musicAttributiveTitle: { defaultMessage: 'Music' },
  televisionAttributiveTitle: { defaultMessage: 'Television' },
  moviesAttributiveTitle: { defaultMessage: 'Movie' },
  animalsAttributiveTitle: { defaultMessage: 'Animal' },
  gamingAttributiveTitle: { defaultMessage: 'Gaming' },
  sportsAttributiveTitle: { defaultMessage: 'Sports' },
  funnyAttributiveTitle: { defaultMessage: 'Funny' },

  // Anime L2s
  animeActionAnime: { defaultMessage: 'Action Anime' },
  animeAdventureAnime: { defaultMessage: 'Adventure Anime' },
  animeFantasyAnime: { defaultMessage: 'Fantasy Anime' },
  animeSciFiAnime: { defaultMessage: 'Sci-Fi Anime' },
  animeRomanceAnime: { defaultMessage: 'Romance Anime' },
  animeComedyAnime: { defaultMessage: 'Comedy Anime' },
  animeSportsMangaAndAnime: { defaultMessage: 'Sports Manga and Anime' },
  animeHorrorAnime: { defaultMessage: 'Horror Anime' },
  animeMinimalistAnime: { defaultMessage: 'Minimalist Anime' },
  animeMysteryAnime: { defaultMessage: 'Mystery Anime' },

  // Music L2s
  musicRapArtistMusic: { defaultMessage: 'Rap Artist Music' },
  music80sPunkBand: { defaultMessage: '80s Punk Band' },
  music70sRockBand: { defaultMessage: '70s Rock Band' },
  musicMetalBand: { defaultMessage: 'Metal Band' },
  musicIndieMusic: { defaultMessage: 'Indie Music' },
  musicMusicalEquipment: { defaultMessage: 'Musical Equipment' },
  musicVinylRecord: { defaultMessage: 'Vinyl Record' },
  musicGlamRock: { defaultMessage: 'Glam Rock' },
  music80sBand: { defaultMessage: '80s Band' },
  musicKpop: { defaultMessage: 'K-Pop' },
  musicGarageBand: { defaultMessage: 'Garage Band' },
  musicEdm: { defaultMessage: 'EDM' },
  musicBluegrassBand: { defaultMessage: 'Bluegrass Band' },
  musicCountryArtist: { defaultMessage: 'Country Artist' },

  // Television L2s
  televisionSitcom: { defaultMessage: 'Sitcom' },
  televisionVintageTv: { defaultMessage: 'Vintage TV' },
  televisionClassicCartoons: { defaultMessage: 'Classic Cartoons' },
  televisionSciFiTv: { defaultMessage: 'Sci-Fi TV' },
  televisionUkTv: { defaultMessage: 'UK TV' },
  televisionTvNostalgia: { defaultMessage: 'TV Nostalgia' },
  televisionWitchesAndWitchcraftRetroTv: {
    defaultMessage: 'Witches and Witchcraft Retro TV',
  },
  televisionSupernaturalCreaturesAndDemons: {
    defaultMessage: 'Supernatural Creatures and Demons',
  },
  televisionMafiaAndLawTv: { defaultMessage: 'Mafia and Law TV' },
  televisionTeenDrama: { defaultMessage: 'Teen Drama' },
  televisionMysteryTv: { defaultMessage: 'Mystery TV' },
  televisionSoapOpera: { defaultMessage: 'Soap Opera' },
  televisionRealityTv: { defaultMessage: 'Reality TV' },
  televisionKdrama: { defaultMessage: 'K-Drama' },
  televisionCowboyTv: { defaultMessage: 'Cowboy TV' },
  televisionWarTv: { defaultMessage: 'War TV' },

  // Movies L2s
  moviesClassicHorrorMovie: { defaultMessage: 'Classic Horror Movie' },
  movies80sMovies: { defaultMessage: '80s Movies' },
  moviesFunnyMovies: { defaultMessage: 'Funny Movies' },
  moviesGangsterMovies: { defaultMessage: 'Gangster Movies' },
  moviesWarMovies: { defaultMessage: 'War Movies' },
  moviesDune: { defaultMessage: 'Dune' },
  moviesSciFiMovies: { defaultMessage: 'Sci-Fi Movies' },
  moviesIndieAndCultClassicMovies: {
    defaultMessage: 'Indie and Cult Classic Movies',
  },
  moviesSuperheroActionMovies: { defaultMessage: 'Superhero Action Movies' },
  moviesAnimationMovie: { defaultMessage: 'Animation Movie' },
  moviesMartialArtsMovies: { defaultMessage: 'Martial Arts Movies' },
  moviesPsychologicalThrillerMovies: {
    defaultMessage: 'Psychological Thriller Movies',
  },
  moviesRomcom: { defaultMessage: 'Romcom' },
  moviesWesternMovie: { defaultMessage: 'Western Movie' },
  moviesPirateMovies: { defaultMessage: 'Pirate Movies' },
  moviesMusicals: { defaultMessage: 'Musicals' },

  // Animals L2s
  animalsDinosaurs: { defaultMessage: 'Dinosaurs' },
  animalsBacteriaAndViruses: { defaultMessage: 'Bacteria and Viruses' },
  animalsSnakesTurtlesAndLizards: {
    defaultMessage: 'Snakes, Turtles and Lizards',
  },
  animalsCatsAndKittens: { defaultMessage: 'Cats and Kittens' },
  animalsFrogs: { defaultMessage: 'Frogs' },
  animalsAxolotls: { defaultMessage: 'Axolotls' },
  animalsBirds: { defaultMessage: 'Birds' },
  animalsDogs: { defaultMessage: 'Dogs' },
  animalsOpossum: { defaultMessage: 'Opossum' },
  animalsOtters: { defaultMessage: 'Otters' },
  animalsRaccoon: { defaultMessage: 'Raccoon' },
  animalsSloth: { defaultMessage: 'Sloth' },
  animalsButterfly: { defaultMessage: 'Butterfly' },
  animalsCaterpillar: { defaultMessage: 'Caterpillar' },
  animalsBees: { defaultMessage: 'Bees' },
  animalsLadyBug: { defaultMessage: 'Lady Bug' },

  // Gaming L2s
  gamingRoleplaying: { defaultMessage: 'Roleplaying' },
  gamingBattleRoyale: { defaultMessage: 'Battle Royale' },
  gamingFps: { defaultMessage: 'FPS' },
  gamingGamer: { defaultMessage: 'Gamer' },
  gamingVideoGames: { defaultMessage: 'Video Games' },
  gamingArcade: { defaultMessage: 'Arcade' },
  gamingZombieGaming: { defaultMessage: 'Zombie Gaming' },
  gamingSkullGaming: { defaultMessage: 'Skull Gaming' },
  gamingBoardGame: { defaultMessage: 'Board Game' },
  gamingRacingGame: { defaultMessage: 'Racing Game' },
  gamingGameController: { defaultMessage: 'Game Controller' },
  gamingChess: { defaultMessage: 'Chess' },
  gamingSolitairePokerBlackjackBridge: {
    defaultMessage: 'Solitaire, Poker, Blackjack and Bridge',
  },

  // Sports L2s
  sportsFootball: { defaultMessage: 'Football' },
  sportsRugby: { defaultMessage: 'Rugby' },
  sportsHockey: { defaultMessage: 'Hockey' },
  sportsBaseball: { defaultMessage: 'Baseball' },
  sportsBasketball: { defaultMessage: 'Basketball' },
  sportsBoxing: { defaultMessage: 'Boxing' },
  sportsMixedMartialArtsAndFighting: {
    defaultMessage: 'Mixed Martial Arts and Fighting',
  },
  sportsCycling: { defaultMessage: 'Cycling' },
  sportsSkiing: { defaultMessage: 'Skiing' },
  sportsGolf: { defaultMessage: 'Golf' },
  sportsTennis: { defaultMessage: 'Tennis' },
  sportsAustralianRulesFootball: {
    defaultMessage: 'Australian Rules Football',
  },
  sportsSurfing: { defaultMessage: 'Surfing' },
  sportsGymWeightliftingAndWorkingOut: {
    defaultMessage: 'Gym, Weightlifting and Working Out',
  },
  sportsCricket: { defaultMessage: 'Cricket' },

  // Funny L2s
  funnyMemes: { defaultMessage: 'Memes' },
  funnyParody: { defaultMessage: 'Parody' },
  funnySarcasm: { defaultMessage: 'Sarcasm' },
  funnyMathScienceAndTech: { defaultMessage: 'Math, Science and Tech' },
  funnyFunnySayings: { defaultMessage: 'Funny Sayings' },
  funnyOffensive: { defaultMessage: 'Offensive' },
  funnyFunnyAnimals: { defaultMessage: 'Funny Animals' },
  funnyParodiesAndMashups: { defaultMessage: 'Parodies and Mashups' },
  funnyPuns: { defaultMessage: 'Puns' },
  funnyFunnyTvShows: { defaultMessage: 'Funny TV Shows' },
  funnyFunnyMovies: { defaultMessage: 'Funny Movies' },

  // Books L2s
  booksChildrensBooks: { defaultMessage: "Children's Books" },
  booksMysteryBook: { defaultMessage: 'Mystery Book' },
  booksComicBook: { defaultMessage: 'Comic Book' },
  booksLiteraryClassics: { defaultMessage: 'Literary Classics' },
  booksPoetry: { defaultMessage: 'Poetry' },
  booksDystopianFiction: { defaultMessage: 'Dystopian Fiction' },
  booksScifiBook: { defaultMessage: 'Sci-Fi Book' },
  booksWizardAndFantasyBooks: { defaultMessage: 'Wizard and Fantasy Books' },
  booksBookQuote: { defaultMessage: 'Book Quote' },
  booksMagazineCover: { defaultMessage: 'Magazine Cover' },
  booksHorrorBook: { defaultMessage: 'Horror Book' },
  booksFairyTales: { defaultMessage: 'Fairy Tales' },
  booksBookLover: { defaultMessage: 'Book Lover' },
  booksPhilosophy: { defaultMessage: 'Philosophy' },
  booksMythology: { defaultMessage: 'Mythology' },
  booksWritersAndNovelists: { defaultMessage: 'Writers and Novelists' },
});
